import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Link } from "react-router-dom";
import api from "../../utils/api";
import {
  successAlert,
  errorAlert,
  loadingAlert,
  closeAlert,
} from "../../utils/swalConfig";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      loadingAlert("Sending reset link...");

      await api.post("/users/forgotPassword", { email });

      closeAlert();
      await successAlert(
        "Success!",
        "Password reset link has been sent to your email. Please check your inbox."
      );
      setEmail("");
    } catch (err) {
      closeAlert();
      const errorMessage =
        err.response?.data?.message || "Failed to send reset link";
      // console.error("Password reset error:", err);
      errorAlert("Error", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" component="h1" gutterBottom align="center">
              Forgot Password
            </Typography>
            <Typography color="textSecondary" align="center" sx={{ mb: 3 }}>
              Enter your email address and we'll send you a link to reset your
              password
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email Address"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{ mb: 3 }}
              />
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                type="submit"
                sx={{ mb: 2 }}
              >
                Send Reset Link
              </LoadingButton>
              <Button component={Link} to="/login" fullWidth color="inherit">
                Back to Login
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
